(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bestiksaet-localization-form"] && !Shopify.designMode) return;
  try {
    if (!window.bskCountryAutosubmitInitialized) {
    window.bskCountryAutosubmitInitialized = true;

    document.addEventListener('change', (event) => {
      const countrySelector = event.target.closest('[data-bsk-country-autosubmit]');

      if (!countrySelector) return;

      const form = countrySelector.form;
      const languageInput = form?.querySelector('[data-bsk-country-language]');
      const countryLanguage = {
        DK: 'da',
        SE: 'sv',
        NO: 'nb',
        DE: 'de',
        FR: 'fr',
      };

      if (languageInput) {
        languageInput.value = countryLanguage[countrySelector.value] || 'en';
      }

      form?.submit();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
